import ManageExpertTable from './ManageExpertTable'

const ManageExpert = {
  Table: ManageExpertTable,
}

export default ManageExpert
